import React from "react";
import type { useAffinityFormReturn } from "affinityForm";

import { PatientFormData, UpdatePatientFormData } from "./types";

export const PatientsFormContext =
  React.createContext<Maybe<useAffinityFormReturn<PatientFormData | UpdatePatientFormData>>>(null);
